import * as React from 'react';
import { ReactElement } from 'react';

import ItemCardSaveIcon from '@/components/GridItemCard/Card/components/ItemCardSaveIcon/ItemCardSaveIcon';
import { useAppSelector } from '@/redux/hooks';
import { getSavedItemCountNum } from '@/redux/modules/savedItemCount';
import { GlobalState } from '@/redux/store';
import { ButtonLocation } from '@/utils/amplitude/analytics';

import { ItemSaveBadge } from './ItemSaveBadge';

export type ItemSaveContainerProps = {
    buttonLocation?: ButtonLocation;
    fire?: boolean;
    fireClassName?: string;
    itemId: number;
    showSavedCount?: boolean;
};

const ItemSaveContainer = ({
    buttonLocation,
    fire,
    fireClassName,
    itemId,
    showSavedCount,
}: ItemSaveContainerProps): ReactElement<ItemSaveContainerProps> => {
    const savedCount = useAppSelector((state: GlobalState) => getSavedItemCountNum(state, itemId));

    return fire ? (
        <ItemSaveBadge
            className={fireClassName}
            savedCount={savedCount}
            showSavedCount={showSavedCount}
        />
    ) : (
        <ItemCardSaveIcon
            buttonLocation={buttonLocation}
            itemId={itemId}
        />
    );
};

export default React.memo<ItemSaveContainerProps>(ItemSaveContainer);
